export default __webpack_public_path__ + "static/media/appium.1982dff1.png";